export default "__VITE_ASSET__5ECduYeQ__"